import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { getFaqQuestionsByCategoryIdAsync, getFaqQuestionByIdAsync, createFaqQuestionAsync, updateFaqQuestionAsync, updateFaqQuestionWithCategoryAsync, deleteFaqQuestionAsync } from './faqQuestionThunk';
const initialState = {
    status: APIStatus.IDLE,
    questions: [],
    selectedQuestion: null
};
export const faqQuestionSlice = createSlice({
    name: 'faqQuestion',
    initialState,
    reducers: {
        clearSelectedQuestion: (state) => {
            state.selectedQuestion = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFaqQuestionsByCategoryIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFaqQuestionsByCategoryIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.questions = action.payload;
        })
            .addCase(getFaqQuestionsByCategoryIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFaqQuestionByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFaqQuestionByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.selectedQuestion = action.payload;
        })
            .addCase(getFaqQuestionByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createFaqQuestionAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createFaqQuestionAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(createFaqQuestionAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateFaqQuestionAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateFaqQuestionAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            const index = state.questions.findIndex((q) => q.id === action.payload.id);
            if (index !== -1)
                state.questions[index] = action.payload;
            if (state.selectedQuestion?.id === action.payload.id) {
                state.selectedQuestion = action.payload;
            }
        })
            .addCase(updateFaqQuestionAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateFaqQuestionWithCategoryAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateFaqQuestionWithCategoryAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (action.payload.data) {
                const index = state.questions.findIndex((q) => q.id === action.payload.data?.id);
                if (index !== -1)
                    state.questions[index] = action.payload.data;
                if (state.selectedQuestion?.id === action.payload.data.id) {
                    state.selectedQuestion = action.payload.data;
                }
            }
        })
            .addCase(updateFaqQuestionWithCategoryAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteFaqQuestionAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteFaqQuestionAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (action.payload.data) {
                state.questions = state.questions.filter((q) => q.id !== action.payload.data?.id);
                if (state.selectedQuestion?.id === action.payload.data?.id) {
                    state.selectedQuestion = null;
                }
            }
        })
            .addCase(deleteFaqQuestionAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { clearSelectedQuestion } = faqQuestionSlice.actions;
export default faqQuestionSlice.reducer;
